import React from 'react';
import styled from 'styled-components';
import {
  colors,
  fonts,
  radii,
  breakpoints,
  icones,
} from '../annuaire/designSystem';
import SvgPhone24 from '../icons/Phone24';
import { icone } from '../../annuaire/tunnel/ui';

const CTABar = styled.div`
  display: grid;
  grid-template-columns: ${(p) => (p.$rdv ? '1fr 72px' : '1fr 1fr')};
  gap: ${(p) => (p.$rdv ? '8px 10px' : '12px')};
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${colors.white};
  padding: ${(p) => (p.$rdv ? '8px 14px 14px' : '12px 16px')};
  box-shadow: 0 -2px 12px rgba(49, 73, 89, 0.1);
  z-index: 99;

  @media (min-width: ${breakpoints.mobile}) {
    display: none;
  }
`;

/* « Réparation à domicile · confirmée instantanément », au-dessus des boutons. */
const Quoi = styled.p`
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-family: ${fonts.body};
  font-size: 12.5px;
  color: ${colors.textSecondary};

  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }

  b {
    font-weight: 600;
    color: ${colors.textDark};
  }
`;

const CTAButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 16px;
  border-radius: ${radii.card};
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 0.85rem;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
`;

const BtnCall = styled(CTAButton)`
  background-color: ${colors.vert};
  color: ${colors.bleuFonce};

  &:hover,
  &:active,
  &:focus {
    color: ${colors.bleuFonce} !important;
    opacity: 1;
  }
`;

const BtnWebsite = styled(CTAButton)`
  background-color: ${colors.bleuFonce};
  color: ${colors.white};

  &:hover,
  &:active,
  &:focus {
    color: ${colors.white} !important;
    opacity: 1;
  }
`;

/**
 * `onPrendreRendezVous` : sur la fiche d'un atelier partenaire (Fixer Lite), la
 * barre porte « Prendre rendez-vous » et un bouton téléphone seul, sous la
 * ligne « Réparation à domicile » et le mode (`instant`) (lot 2, validé le
 * 22/09). Le site reste dans les infos pratiques.
 */
export default function MobileCTABar({
  shop,
  onPrendreRendezVous = null,
  instant = false,
  tel = null,
}) {
  const details = shop.details || {};
  // Fixer Lite : le même numéro que la carte de rendez-vous (`useRdvAtelier`).
  const phone = tel || shop.phone || details.telephone_google || '';
  const website = shop.website || details.site_web || '';

  // Don't render if no phone and no website
  if (!phone && !website && !onPrendreRendezVous) return null;

  if (onPrendreRendezVous) {
    return (
      <CTABar $rdv>
        <Quoi>
          <img src={icone(instant ? 'ENERGIE' : 'CALENDRIER')} alt="" />
          <b>Réparation à domicile</b>·
          {instant ? ' confirmée instantanément' : ' confirmée par email'}
        </Quoi>
        <BtnCall
          as="button"
          type="button"
          onClick={onPrendreRendezVous}
          style={phone ? null : { gridColumn: '1 / -1' }}>
          Prendre rendez-vous
        </BtnCall>
        {phone && (
          <BtnWebsite href={`tel:${phone}`} aria-label="Appeler le réparateur">
            <SvgPhone24 color={colors.white} aria-hidden="true" />
          </BtnWebsite>
        )}
      </CTABar>
    );
  }

  return (
    <CTABar>
      {phone ? (
        <BtnCall href={`tel:${phone}`}>
          <img
            src={icones.smartphone}
            alt=""
            style={{ height: 18, width: 'auto', objectFit: 'contain' }}
          />{' '}
          Appeler
        </BtnCall>
      ) : (
        <div />
      )}
      {website ? (
        <BtnWebsite href={website} target="_blank" rel="noopener noreferrer">
          Site web
        </BtnWebsite>
      ) : (
        <div />
      )}
    </CTABar>
  );
}
